module.exports = __webpack_public_path__ + "static/media/clix_dashboard_login_image.691c52c4.png";